export const environment = {
    production: true,
    API: 'https://api-dev.mindtest.com.br/api',
    urlMidias: 'https://api-dev.mindtest.com.br',
    urlArquivosEstaticos: 'https://pro.mindtest.com.br/static',
    URL_SISTEMA: 'https://frontend-dev.mindtest.com.br'
};
